module.exports = __webpack_public_path__ + "front/img/d12.5bec87fc.png";